// actions/TransactionSettingAction.js
import {
    getTransactionSettings,
    saveTransactionSettings,
  } from "../../services/TransactionSettingService";
  import {formatSuccess, formatError} from '../../services/commonServices'
  
  export const TRANSACTION_SETTING_INITIATED = "TRANSACTION_SETTING_INITIATED";
  export const TRANSACTION_SETTING_LOADED = "TRANSACTION_SETTING_LOADED";
  export const TRANSACTION_SETTING_FAILED = "TRANSACTION_SETTING_FAILED";
  export const TRANSACTION_SETTING_SAVED = "TRANSACTION_SETTING_SAVED";
  
  export function loadTransactionSettings() {
    return (dispatch) => {
      dispatch({ type: TRANSACTION_SETTING_INITIATED });
      getTransactionSettings()
        .then((response) => {
          dispatch({
            type: TRANSACTION_SETTING_LOADED,
            payload: response.data[0],
          });
        })
        .catch((error) => {
          dispatch({
            type: TRANSACTION_SETTING_FAILED,
            payload: formatError(error.response?.data),
          });
        });
    };
  }
  
  export function saveTransactionSettingsAction(data) {
    return (dispatch) => {
      dispatch({ type: TRANSACTION_SETTING_INITIATED });
      return saveTransactionSettings(data)
        .then((response) => {
          dispatch({
            type: TRANSACTION_SETTING_SAVED,
            payload: response.data,
          });
          formatSuccess('Transaction Settings',response)
        })
        .catch((error) => {
          dispatch({
            type: TRANSACTION_SETTING_FAILED,
            payload: formatError(error.response?.data),
          });
          throw error;
        });
    };
  }
  